'use client';

const stats = [
  { value: '77%', label: "don't create", desc: 'Employees held back by blank page anxiety', color: '#EF4444' },
  { value: '8x', label: 'more engagement', desc: 'Employee posts vs brand posts on LinkedIn', color: '#10B981' },
  { value: '24x', label: 'more shares', desc: 'Employee content vs corporate content', color: '#3B82F6' },
  { value: '2.4x', label: 'more authentic', desc: 'How consumers perceive employee content', color: '#8B5CF6' },
];

export default function TrendSection() {
  return (
    <section className="py-14">
      <div className="max-w-[1200px] mx-auto px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-5">
          {stats.map((stat) => (
            <div
              key={stat.value}
              className="text-center py-7 px-4 bg-card border border-border rounded-[16px] transition-all hover:-translate-y-1 hover:shadow-md"
            >
              <div
                className="text-[40px] font-bold tracking-[-2px] leading-none mb-0.5"
                style={{ color: stat.color }}
              >
                {stat.value}
              </div>
              <div className="font-semibold text-[14px] text-foreground mb-0.5">{stat.label}</div>
              <div className="text-[12px] text-muted-foreground">{stat.desc}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
